export default "__VITE_ASSET__9129d51f__"